import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Toolbar from '../../components/common/Toolbar';
import OrdersTable from '../../components/blocks/OrdersTable';

import {
  getDropshipOrders,
  getDropshipOrdersFilters,
  setDropshipOrdersOffset,
  setDropshipOrdersPerPage,
  setDropshipOrdersSearchById,
  setDropshipOrdersSort,
  setDropshipOrdersLoading,
} from '../../store/actions/dropshipOrders';

import { retailerGetOrder } from '../../store/actions/retailerOrders';

function DropshipOrdersContainer(props) {
  const { getOrders, getOrdersFilters } = props;

  useEffect(() => {
    getOrders();
    getOrdersFilters();
  }, [getOrders, getOrdersFilters]);

  return (
    <>
      <Toolbar name="Orders" />
      <OrdersTable {...props} />
    </>
  );
}

const mapStateToProps = (state) => {
  const { data, isLoading, retailers, offset, search, perPage, count, sort, statusCount } = state.dropshipOrders;

  const { suppliersNames } = state.role;
  const { orderModal } = state.retailerOrders;

  return {
    data,
    isLoading,
    retailers,
    offset,
    search,
    perPage,
    count,
    sort,
    statusCount,
    orderModal,
    suppliersNames,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getOrders: () => dispatch(getDropshipOrders()),
  getOrdersFilters: () => dispatch(getDropshipOrdersFilters()),
  setOffset: (offset) => dispatch(setDropshipOrdersOffset(offset)),
  setPerPage: (perPage) => dispatch(setDropshipOrdersPerPage(perPage)),
  filterById: (count) => dispatch(setDropshipOrdersSearchById(count)),
  setSort: (field) => dispatch(setDropshipOrdersSort(field)),
  setDropshipOrdersLoading: (bool) => dispatch(setDropshipOrdersLoading(bool)),
  openOrderModal: (order) => dispatch(retailerGetOrder(order)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DropshipOrdersContainer);

DropshipOrdersContainer.propTypes = {
  data: PropTypes.array.isRequired,
  getOrders: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  getOrdersFilters: PropTypes.func.isRequired,
  setDropshipOrdersLoading: PropTypes.func.isRequired,
  openOrderModal: PropTypes.func.isRequired,
  suppliersNames: PropTypes.object,
};
